import { useNavigate } from "react-router-dom";
import urls from "../../routes";
import ConfirmationModal from "../../ui/Modal/ConfirmationModal";
import SwitchCard from "../../ui/SwitchCard/SwitchCard";
import { useState } from "react";
import styles from "./PublishModal.module.scss";
import { Send } from "../../ui/Icon/Icon";

function PublishModal({
  onClose,
  onSubmit,
  fetching,
  canPublish,
  articleCounts,
}: {
  onClose: () => void;
  onSubmit: (republish: boolean) => Promise<void>;
  fetching: boolean;
  canPublish: boolean;
  articleCounts?: {
    total: number;
    published: number;
  };
}) {
  const [republish, setRepublish] = useState(true);
  const navigate = useNavigate();

  if (!canPublish) {
    return (
      <ConfirmationModal
        onClose={onClose}
        confirmationText="Connect"
        onSubmit={() => navigate(urls.publishing.root)}
      />
    );
  }

  return (
    <>
      {articleCounts &&
        setRepublish &&
        republish !== undefined &&
        articleCounts.published > 0 &&
        articleCounts.published !== articleCounts.total && (
          <SwitchCard
            className={styles.card}
            IconComponent={Send}
            checked={republish}
            onToggle={() => setRepublish((previous) => !previous)}
            title={`Republish ${articleCounts.published} ${
              articleCounts.published === 1 ? "article" : "articles"
            }`}
            subtitle="This will replace articles on your site"
          />
        )}
      <ConfirmationModal
        onClose={onClose}
        onSubmit={() => onSubmit(republish)}
        loading={fetching}
      />
    </>
  );
}

export default PublishModal;
